import styled from "styled-components";
import { themeGet } from '@styled-system/theme-get'

const SVG = styled.svg`
    fill: ${({ fill }) => fill ? themeGet(`colors.${fill}`, fill) : 'black'}
`

export default SVG